"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationCommon_de_de = void 0;
function applicationCommon_de_de() {
    return {
        "applications.title": "Arbeitstitel",
        "applications.empty.headline": "Erstellen Sie Ihre erste Applikation",
        "applications.empty.message": "Applikationen sind der beste und einfachste Weg um Ihren Kunden Ihre Inhalte bereitzustellen. Applikationen können von jedem Browser angezeigt und auf Android & iOS Geräten installiert werden.",
        "applications.empty.create": "Applikation erstellen",
        "applications.creationdialog.title": "Neue Applikation erstellen",
        "applications.creationdialog.description": "Vergeben Sie einen Arbeitstitel für Ihre neue App. Dieser dient lediglich zur Wiedererkennung für Sie und Ihre Kollegen.",
        "applications.deletion.title": "Applikation löschen",
        "applications.deletion.message": "Wollen Sie die Applikation wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden. Erstellte Inhalte bleiben erhalten."
    };
}
exports.applicationCommon_de_de = applicationCommon_de_de;
